import { FvButton } from '@fv/client-components'

import { InputAdornment } from '@/components/inputs/InputGroup'

import type { AddressBookListConfig, SetAddress } from './types'
import { useAddressBook } from './useAddressBook'

type Props = {
  disabled?: boolean
  config: AddressBookListConfig
  setAddress: SetAddress
}

export const AddressBookButton = ({ disabled, setAddress, config }: Props) => {
  const addressBook = useAddressBook()

  return (
    <InputAdornment position="start">
      <FvButton
        aria-label="Open address book"
        theme="default"
        disabled={disabled}
        icon="book"
        onClick={() => addressBook.open(setAddress, config)}
        title="Address book"
      />
    </InputAdornment>
  )
}
